import InputHandler from "./InputHandler";
import {MdDelete} from "react-icons/md";
import React from "react";
import {ButtonActionStyled, SkillsCardStyled} from "../../../styled/Resume";
import {FaPlus} from "react-icons/fa6";
import {useTheme} from "../../UI/Theme/ThemeContext";


const SkillsCard = (props)=> {
    const {
        skills,
        handleSkillChange,
        handleDeleteSkill,
        handleAddSkill,
        interests,
        handleInterestChange,
        handleDeleteInterests,
        handleAddInterests,


    } = props;
    const {themeName} = useTheme();

    return (
        <SkillsCardStyled theme={themeName}>
            <div className="input">
                {interests && interests.map((interest, index) => (
                    <div style={{display:'flex', gap:'1rem'}} key={index}>
                    <InputHandler
                        key={index}
                        id={interest + index}
                        value={interest}
                        label="Type a Hobby"
                        type="text"
                        required={true}
                        onChange={(event) => handleInterestChange(event, index)}
                    />
                    {interests && 
                        <ButtonActionStyled skill>
                            <span className="del" onClick={handleDeleteInterests}> <MdDelete/> </span>
                        </ButtonActionStyled>
                    }

                    </div>


                ))}

                {skills && skills.map((skill, index) => (
                    <div style={{display:'flex', gap:'1rem'}} key={index}>
                        <InputHandler
                            key={index}
                            id={skill + index}
                            value={skill}
                            label="Type a Skill"
                            type="text"
                            required={true}
                            onChange={(event) => handleSkillChange(event, index)}
                        />
                        {skills &&
                            <ButtonActionStyled skill>
                                <span className="del" onClick={handleDeleteSkill}> <MdDelete/> </span>
                            </ButtonActionStyled>
                        }
                    </div>
                    
                ))}
            </div>

            {skills && <ButtonActionStyled skill>
                <span className="add" onClick={handleAddSkill}> <FaPlus/> </span>
            </ButtonActionStyled>}

            {interests && <ButtonActionStyled skill>
                <span className="add" onClick={handleAddInterests}> <FaPlus/> </span>
            </ButtonActionStyled>}



        </SkillsCardStyled>


    );
}

export default SkillsCard;